module.exports = __webpack_public_path__ + "img/gentlemen-club-collection-18.66069a7e.png";